import React, { useContext, useRef } from "react";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { withRouter, Link, useLocation, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { TklLOGO } from "../utility/TKLLogo";
import { useForm } from "react-hook-form";
import {
  RestrictCopyPasteHandler,
  UseToggle,
  isFreeUser
} from "../utility/ReUsableFunctions";
import "./login.scss";
import "../CourseCreation/createCourse.scss";
import "../UserRegister/register.scss";
import {
  sendResetLink,
  passwordReset,
  loginUser,
} from "../../actions/RegisrationActions/registerActions";
import { TKLModal } from "../../shared-components/model/TKLModal";
import queryString from "query-string";
import { store } from "../../App";

const PageLogin = ({
  props,
  history,
  sendResetLink,
  apiSuccessMessage,
  passwordReset,
  apiErrorMessage,
  loginUser,
}) => {
  const btnClick = useRef(null);
  const { pathname } = history?.location;
  const { search } = useLocation();
  const { uuid, slug } = queryString.parse(search);
  const [showView, setView] = React.useState("/loginPage");
  const [showPassword, setShowPassword] = UseToggle(false);
  const authToken = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.users.userData);

  React.useEffect(() => {

    let postId = +sessionStorage.getItem("bookmarkPostId");
    if (postId) {
      sessionStorage.removeItem("bookmarkPostId");
    }
    else if (slug) {
      // history.push('/informationSheets')
      localStorage.setItem("informationSheets", slug);
    } else if (localStorage.getItem("cartData")) {
      history.push("/toCart");
    }
    else if (
      (authToken !== "" || localStorage.getItem("token")) &&
      !pathname.includes("/forgotPassword")
    ) {
      if (isFreeUser(userData?.roles)) {
        history.push("/community");
      }
      else {
        // history.push("/");
      }
    }
  }, [authToken]);

  React.useEffect(() => {
    if (
      !pathname.includes("changePassword") &&
      pathname !== "/loginPage" &&
      !pathname.includes("/forgotPassword")
    ) {
      if (pathname?.includes('/community/PostItem/')) {
        let postId = +pathname.split('/community/PostItem/')[1]
        sessionStorage.setItem('bookmarkPostId', postId)
      }
      history.push("/loginPage");

    }
  }, []);
  React.useEffect(() => {
    setView(pathname);
  }, [pathname]);

  const passwordIconClicked = (event, id) => {
    setShowPassword((showPassword) => !showPassword);
    if (!showPassword) {
      let element = document.getElementById(id);
      element.setAttribute("type", "text");
    } else {
      let element = document.getElementById(id);
      element.setAttribute("type", "password");
    }
  };
  const LoginFormContainer = () => {
    const {
      register,
      handleSubmit,
      getValues,
      setValue,
      formState: { errors },
    } = useForm({});
    const onSubmit = (data) => {
      loginUser(history, data);
    };

    const handleKeypress = (e) => {
      if (e.key === "Enter") {
        btnClick.current.click();
      }
    };

    return (
      <Form className="login-container">
        <Form.Group >
          {/* controlId="loginemail" */}
          <Form.Label>
            <strong>Email Address</strong>
          </Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter Email Address"
            className="rounded-pill"
            {...register("email", {
              required: true,
              pattern: {
                value: /\S+@\S+\.\S+/,
              },
            })}
            name="email"
          />
          {errors.email && (
            <p style={{ marginTop: "14px" }} className="show-txt-error">
              Invalid Email
            </p>
          )}
        </Form.Group>
        {/* controlId="loginpassword" */}
        <Form.Group className="pwd-div-login">
          <Form.Label>
            <strong>Password</strong>
          </Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter Password"
            className="rounded-pill"
            id={`login-pwd`}
            onKeyPress={handleKeypress}
            {...register("password", {
              required: true,
              // pattern: {
              //   value:
              //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
              // },
            })}
            name="password"
          />
          {!showPassword ? (
            <span
              className="material-icons password-icon-visible"
              onClick={(event) => passwordIconClicked(event, "login-pwd")}
            >
              visibility
            </span>
          ) : (
            <span
              className="material-icons password-icon-visible"
              onClick={(event) => passwordIconClicked(event, "login-pwd")}
            >
              visibility_off
            </span>
          )}

          {errors.password && (
            <p style={{ marginTop: "14px" }} className="show-txt-error">
              Invalid Password
            </p>
          )}
        </Form.Group>
        <div className="btn-holder text-center">
          <Button
            type="button"
            ref={btnClick}
            className="btn btn-outline btn-blue btn-rounded mb-2 rounded-pill"
            title="Sign In"
            onClick={handleSubmit(onSubmit)}
            style={{ marginRight: "2em" }}
          >
            Sign In
          </Button>

          <Link
            //type="button"
            disabled
            className="btn btn-outline btn-secondary btn-rounded mb-2 rounded-pill create_newAccount2"
            title="Register"
            // onClick={toLoginPage}
            to={"/register"}
          >
            Create a New Account
          </Link>
        </div>
        <div className="text-center">
          <hr />
          <Link to="/forgotPassword">Forgot Password?</Link>
        </div>
      </Form>
    );
  };

  const ForgotPasswordContainer = () => {
    const {
      register,
      handleSubmit,
      getValues,
      setValue,
      formState: { errors },
    } = useForm({});
    const onSubmit = (data) => {
      sendResetLink(history, data.email, null);
    };
    return (
      <Form>
        <Form.Group controlId="loginemail">
          <Form.Label>
            <strong>Email Address</strong>
          </Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter Email Address"
            className="rounded-pill"
            {...register("email", {
              required: true,
              pattern: {
                value: /\S+@\S+\.\S+/,
              },
            })}
            name="email"
          />
          {errors.email && (
            <p
              className="show-txt-error"
              style={{ marginTop: "1em", fontSize: "16px" }}
            >
              Invalid Email
            </p>
          )}
        </Form.Group>
        <div className="btn-holder text-center">
          <Button
            type="button"
            className="btn btn-outline btn-secondary btn-rounded mb-2 rounded-pill"
            title="Go back"
            style={{ marginRight: "0.5em" }}
            onClick={() => {
              localStorage.getItem("token")
                ? history.push("/createProfile")
                : history.push("/loginPage");
            }}
          >
            Go back
          </Button>
          <Button
            type="button"
            className="btn btn-outline btn-blue btn-rounded mb-2 rounded-pill"
            title="Send Reset password link"
            onClick={handleSubmit((data) => onSubmit(data))}
          >
            Send Reset password link
          </Button>
        </div>
      </Form>
    );
  };

  const resetPasswordFields = (
    register,
    handleSubmit,
    getValues,
    setValue,
    errors
  ) => {
    const onSubmit = (data) => {
      passwordReset(history, data, uuid);
    };
    return (
      <div className="reset-pwd-container">
        <div className="form-group-create pwd-div">
          <label className="form-label">
            <strong className={`${errors.newPassword && "show-validation-text-error"
              }`}>New Password</strong>
            <small style={{ fontWeight: "600" }}>
              Needs to be a minimum of 8 characters which includes at least
              one capital letter, one lower case, one number, and one
              special character (i.e !,@,#,$,&)
            </small>
          </label>
          <div className="mb-3 input-group password-show-container">
            <input
              placeholder={`Enter Password`}
              type="password"
              id={"TKL-register-create-pwd"}
              className={`input-caret rounded-pill form-control form-control-sm input-width-style`}
              {...register("newPassword", {
                required: true,
                pattern: {
                  value:
                    // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$&])[A-Za-z\d!@#$&]{8,}$/,
                },
              })}
              name="newPassword"
              onCopy={RestrictCopyPasteHandler}
              onCut={RestrictCopyPasteHandler}
              onPaste={RestrictCopyPasteHandler}
            />
          </div>
          {!showPassword ? (
            <span
              className="material-icons password-icon-visible"
              onClick={(event) =>
                passwordIconClicked(event, "TKL-register-create-pwd")
              }
            >
              visibility
            </span>
          ) : (
            <span
              className="material-icons password-icon-visible"
              onClick={(event) =>
                passwordIconClicked(event, "TKL-register-create-pwd")
              }
            >
              visibility_off
            </span>
          )}
          {/* {errors.newPassword && (
            <p style={{ fontSize: "14px" }} className="show-txt-error">
              {" "}
              <i>
                Password should be a minimum of 8 characters with at least one
                capital letter, one small letter, one numeric, and one special
                character (!,@,#,$,&)
              </i>
            </p>
          )} */}
        </div>
        <div className="form-group-create">
          <label className="form-label">
            <strong>Confirm Password</strong>
          </label>
          <div className="mb-3 input-group">
            <input
              placeholder={`Confirm Password`}
              type="password"
              className={`input-caret rounded-pill form-control form-control-sm input-width-style`}
              {...register("confirmPassword", {
                required: true,
                validate: (value) => value === getValues("newPassword"),
              })}
              name="confirmPassword"
              onCopy={RestrictCopyPasteHandler}
              onCut={RestrictCopyPasteHandler}
              onPaste={RestrictCopyPasteHandler}
            />
          </div>
          {errors.confirmPassword && (
            <p className="show-txt-error">Passwords are not matching</p>
          )}
        </div>
        <div className="btn-holder text-center">
          <Button
            type="button"
            className="btn btn-outline btn-secondary btn-rounded mb-2 rounded-pill"
            title="Go back"
            // onClick={handleSubmit(onSubmit)}
            onClick={() => {
              history.push("/loginPage");
            }}
            style={{ marginRight: "0.5em" }}
          >
            Go back
          </Button>

          <Button
            type="button"
            className="btn btn-outline btn-blue btn-rounded mb-2 rounded-pill"
            title="Update Password"
            // onClick={handleSubmit(onSubmit)}
            onClick={handleSubmit((data) => onSubmit(data))}
          >
            Update Password
          </Button>
        </div>
      </div>
    );
  };
  const ResetPasswordContainer = () => {
    const {
      register,
      handleSubmit,
      getValues,
      setValue,
      formState: { errors },
    } = useForm({});
    return (
      <Form>
        {resetPasswordFields(
          register,
          handleSubmit,
          getValues,
          setValue,
          errors
        )}
      </Form>
    );
  };
  const showViewBasedOnPathName = () => {
    switch (showView) {
      case "/loginPage":
        return LoginFormContainer();
      case "/forgotPassword":
        return ForgotPasswordContainer();
      case "/changePassword":
        return ResetPasswordContainer();
      default:
        return LoginFormContainer();
    }
  };
  return (
    <>
      <main className="pg-main p-0">
        <div
          className="login-wrap d-flex justify-content-center align-items-center"
          style={{ backgroundImage: 'url("login-bg-1.jpg")' }}
        >
          <div className="p-3 p-md-4 p-xl-5 login-content">
            <TklLOGO svgId={"login_layer"} />

            {/* Toggle between views*/}

            {showViewBasedOnPathName()}

          </div>
        </div>
      </main>
      {apiSuccessMessage && (
        <TKLModal
          showDialog={true}
          msgType={"success"}
          message={apiSuccessMessage}
          isRegisterPage={true}
        />
      )}
      {apiErrorMessage && (
        <TKLModal
          showDialog={true}
          msgType={"warning"}
          message={apiErrorMessage}
          type="error"
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    apiSuccessMessage: state.coursepath.apiSuccessMessage,
    apiErrorMessage: state.coursepath.apiErrorMessage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendResetLink: (history, email, firstName) => dispatch(sendResetLink(history, email, firstName)),
    passwordReset: (history, userData, uui) =>
      dispatch(passwordReset(history, userData, uui)),
    loginUser: (history, data) => dispatch(loginUser(history, data)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PageLogin));
